import type { SoundtrackListEntry } from "../types";

type Props = {
  tracks: SoundtrackListEntry[];
  activeMixVersion: number | null;
  disabled?: boolean;
  onSelect: (mixVersion: number) => void;
};

function sourceLabel(s: SoundtrackListEntry["source"]): string {
  if (s === "voice") return "Voice";
  if (s === "auto") return "Auto";
  return "Text";
}

export function SoundtrackList({
  tracks,
  activeMixVersion,
  disabled,
  onSelect,
}: Props) {
  return (
    <aside className="soundtrack-sidebar panel">
      <h3 className="soundtrack-sidebar__title">Soundtracks</h3>
      <p className="soundtrack-sidebar__hint muted">
        Each render is saved. Tap to play.
      </p>
      {tracks.length === 0 ? (
        <p className="soundtrack-sidebar__empty muted">
          No tracks yet — send a command or try a demo style.
        </p>
      ) : (
        <ul className="soundtrack-list">
          {tracks.map((t) => {
            const active = activeMixVersion === t.mixVersion;
            return (
              <li key={t.mixVersion}>
                <button
                  type="button"
                  className={`soundtrack-list__item${active ? " soundtrack-list__item--active" : ""}`}
                  disabled={disabled}
                  onClick={() => onSelect(t.mixVersion)}
                  title={t.title}
                >
                  <span className="soundtrack-list__name">{t.title}</span>
                  <span className="soundtrack-list__meta">
                    v{t.mixVersion} · {sourceLabel(t.source)}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </aside>
  );
}
